import * as yup from 'yup'

export const validationSchema = yup.object().shape({
  email: yup.string().email('Introduzca un e-mail valido').required('Este campo es obligatorio'),
  password: yup
    .string()
    .min(8, 'Utiliza al menos 8 caracteres')
    .required('Este campo es obligatorio'),
})
